import React, { useEffect, useState } from 'react';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AtomData from './pages/AtomData';
import PhoneTypeChecker from './pages/PhoneTypeChecker';
import GetAddress from './pages/GetAddress';
import GetIncidents from './pages/GetIncidents';
import SerpData from './pages/SerpData';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    // ✅ Check localStorage on app load
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  const handleLogin = () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');  // ✅ Save to localStorage
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');  // ✅ Clear from localStorage
  };

  useEffect(() => {
    // Optional: Listen for storage changes from other tabs
    const onStorageChange = () => {
      const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
      setIsLoggedIn(loggedIn);
    };

    window.addEventListener('storage', onStorageChange);
    return () => window.removeEventListener('storage', onStorageChange);
  }, []);

  return (
    <Router>
      <Routes>
        {/* <Route path="/Sample" element={<Sample onLogout={handleLogout} />} /> */}
        <Route path="/" element={
          isLoggedIn ? (
            <Dashboard onLogout={handleLogout} />
          ) : (
            <Login onLoginSuccess={handleLogin} />
          )
        } />
        <Route path="/AtomData" element={<AtomData />} />
        <Route path="/GetIncidents" element={<GetIncidents />} />
        <Route path="/PhoneTypeChecker" element={<PhoneTypeChecker/>} />
        <Route path="/GetAddress" element={<GetAddress/>} />
        <Route path="/SerpData" element={<SerpData/>} />
      </Routes>
    </Router>
  );
}

export default App;

